import { render, staticRenderFns } from "./MenuNavegacao.vue?vue&type=template&id=14bfe9d1"
import script from "./MenuNavegacao.vue?vue&type=script&lang=js"
export * from "./MenuNavegacao.vue?vue&type=script&lang=js"
import style0 from "./MenuNavegacao.vue?vue&type=style&index=0&id=14bfe9d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports